import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionLogixProfiles extends Layout {
    sourceDpsqlh: DataSource;
    sourceDxfunction: DataSource;
    sourceDxmasterp: DataSource;
    sourceDxmwpgs: DataSource;
    sourceDxproject: DataSource;
    sourceRenditionLogixProfiles: DataSource;
    textboxLgxpColor: Textbox;
    textboxLgxpCombinetype: Textbox;
    textboxLgxpFname: Textbox;
    textboxLgxpFormat: Textbox;
    textboxLgxpId: Textbox;
    textboxLgxpLogin: Textbox;
    textboxLgxpMid: Textbox;
    textboxLgxpPrefid: Textbox;
    textboxLgxpPwd: Textbox;
    textboxLgxpSepinv: Textbox;
    textboxLgxpUrl: Textbox;
}
